import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
	return (
		<div className='uiowa-footer'>
			<div className='content'>
				<div className='first-item'>
					<div className='left'>
						<div className='contact'>
							<h1 className='logo'>UIOWA</h1>
							<span className='address'>Iowa City, Iowa 52242</span>
							<br />
							<div className='d-flex align-items-center gap-3'>
								<i
									className='fa fa-phone'
									style={{ color: "#ccc" }}
									aria-hidden='true'
								></i>
								<Link>319-335-3500</Link>
							</div>
							<div className='d-flex align-items-center gap-3'>
								<i
									className='fa fa-envelope-o'
									style={{ color: "#ccc" }}
									aria-hidden='true'
								></i>
								<Link>Contact Us</Link>
							</div>
							<div className='d-flex align-items-center gap-3'>
								<i
									className='fa fa-envelope-o'
									style={{ color: "#ccc" }}
									aria-hidden='true'
								></i>
								<Link>Website Feedback</Link>
							</div>
						</div>
						<div className='socials d-flex align-items-center gap-4'>
							<Link>
								<i className='fa fa-facebook-square' aria-hidden='true'></i>
							</Link>
							<Link>
								<i className='fa fa-twitter-square' aria-hidden='true'></i>
							</Link>
							<Link>
								<i className='fa fa-instagram' aria-hidden='true'></i>
							</Link>
							<Link>
								<i className='fa fa-snapchat' aria-hidden='true'></i>
							</Link>
							<Link>
								<i className='fa fa-youtube-play' aria-hidden='true'></i>
							</Link>
							<Link>
								<i className='fa fa-pinterest' aria-hidden='true'></i>
							</Link>
						</div>

						<div className='d-flex align-items-center gap-2'>
							<i
								className='fa fa-sign-in'
								style={{ color: "#ccc" }}
								aria-hidden='true'
							></i>
							<Link>Admin Login</Link>
						</div>
					</div>
					<div className='right row'>
						<div className='col-md-4 d-flex flex-column gap-1'>
							<Link>Employee Self-service</Link>
							<Link>ICON</Link>
							<Link>MAUI</Link>
							<Link>MyUI</Link>
							<Link>Office365 (email)</Link>
							<Link>Student Outcomes</Link>
							<Link>Zoom Login</Link>
						</div>
						<div className='col-md-4 d-flex flex-column gap-1'>
							<Link>Footer secondary</Link>
							<Link>Academic Calendar</Link>
							<Link>Billing Office</Link>
							<Link>Directory</Link>
							<Link>General Catalog</Link>
							<Link>Human Resources</Link>
							<Link>Jobs@Iowa</Link>
							<Link>Libraries</Link>
						</div>
						<div className='col-md-4 d-flex flex-column gap-1'>
							<Link>A-Z List</Link>
							<Link>Campus Map</Link>
							<Link>Campus Safety</Link>
							<Link>Emergency Info</Link>
							<Link>Covid-19 Information</Link>
							<Link>Student Health</Link>
							<Link>Free Speech at Iowa</Link>
						</div>
					</div>
				</div>
				<div className='second-item'>
					<p
						dangerouslySetInnerHTML={{
							__html: `&copy;${new Date().getFullYear()}  The University of Iowa`,
						}}
					></p>
					<div className='d-flex gap-2'>
						<Link>Privacy Notice</Link>
						<Link>Nondiscrimination Statement</Link>
						<Link>Accessibility</Link>
						<Link>UI Indigenous Land Acknowledgement</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
